import React, { Component, EventHandler } from 'react'
import { createStyles, WithStyles, withStyles, Paper, Switch, FormControlLabel, Button, CircularProgress, IconButton, Icon } from '@material-ui/core'
import { connect } from 'react-redux'
import { TExercise } from './@types';
import { withRouter, RouteComponentProps } from 'react-router';
import MuiTheme from '../../MuiTheme';
import { ReduxStore } from '../../stores';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { TextField } from '@material-ui/core';
import { ThunkDispatch } from 'redux-thunk';
import { OExercise } from './Model';
import { Editor } from '@tinymce/tinymce-react';
import { TINY_API_KEY } from 'Resources/Config';

interface IStateProps { }

interface IDispatchProps {
    submitForm: (formData: Partial<TExercise>) => any
}

interface IState {
    showForm: boolean
    formData: Partial<TExercise>
    submittingForm: boolean
    viewSource: boolean
    showImagePicker: boolean
}

interface OwnProps {
    open: boolean
    exercise?: TExercise
    onClose?: () => void
}

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps, RouteComponentProps<{ sectionId: string }>, OwnProps {

}

class Form extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            showForm: this.props.open,
            viewSource: false,
            formData: {
                question: '',
                answer: '',
                sectionId: this.props.match.params['sectionId']
            },
            submittingForm: false,
            showImagePicker: false
        };
    }

    componentDidMount() {
        const { exercise } = this.props;
        if (exercise) this.setState({ formData: { ...this.state.formData, ...exercise } });
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            formData: { ...this.state.formData, [e.target['name']]: e.target['value'] }
        })
    }

    contentChanged: EventHandler<any> = (event) => {
        this.setState({
            formData: { ...this.state.formData, answer: event.target.getContent() },
        })
    }

    handleSubmit = async () => {
        this.setState({ submittingForm: true });
        const res = await this.props.submitForm(this.state.formData).catch((error: any) => this.setState({ submittingForm: false }));
        if (res) {
            this.handleClose();
        }
        // this.setState({ submittingForm: false });
    }

    imageHandler = () => this.setState({ showImagePicker: true });

    codeBlockHandler = () => { }

    handleClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
        this.setState({ showForm: false });
    }

    render() {
        const { classes, exercise } = this.props;
        const { submittingForm, formData } = this.state;
        return (
            <div>
                <ValidatorForm
                    onSubmit={this.handleSubmit}
                >
                    <Paper className={classes.formPaper} >
                        <TextValidator
                            type='number'
                            placeholder='Question Number'
                            fullWidth
                            name='number'
                            value={formData.number || ''}
                            onChange={this.handleChange}
                            autoComplete={'off'}
                            validators={['required', 'isPositive']}
                            errorMessages={['This field is required', 'Only positive numbers are allowed']}
                        />
                        <TextValidator
                            placeholder='Question'
                            fullWidth
                            name='question'
                            value={formData.question || ''}
                            onChange={this.handleChange}
                            autoComplete={'off'}
                            multiline
                            validators={['required']}
                            errorMessages={['This field is required']}
                        />
                        {
                            <FormControlLabel
                                control={
                                    <Switch
                                        color='primary'
                                        checked={this.state.viewSource}
                                        onChange={() => this.setState(state => ({ viewSource: !state.viewSource }))}
                                    />
                                }
                                label='View Source'
                            />
                        }
                        {
                            !this.state.viewSource &&
                            <Editor
                                apiKey={TINY_API_KEY}
                                init={{
                                    plugins: 'link image code fullscreen table codesample hr lists visualblocks preview',
                                    toolbar: 'fullscreen undo redo | preview visualblocks numlist bullist bold italic | alignleft aligncenter alignright hr | codesample code | link image | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                                    codesample_languages: [
                                        { text: 'C', value: 'c' },
                                        { text: 'C++', value: 'csharp' },
                                        { text: 'Java', value: 'java' }
                                    ],
                                }}
                                initialValue={formData.answer || ''}
                                onChange={this.contentChanged}
                            />
                        }
                        <div id='answer' />
                        {
                            this.state.viewSource &&
                            <TextField
                                multiline
                                value={formData.answer || ''}
                                onChange={this.handleChange}
                                name='answer'
                                variant='outlined'
                                fullWidth
                                id='answer'
                            />
                        }
                        <Button type='submit' variant='contained' color='primary' className={classes.saveButton} >
                            {
                                submittingForm
                                    ?
                                    <CircularProgress color='inherit' size={26} thickness={5} />
                                    : (exercise ? 'UPDATE' : 'SAVE')
                            }
                        </Button>
                        <IconButton onClick={this.handleClose} className={classes.backButton} >
                            <Icon color='primary' >arrow_back</Icon>
                        </IconButton>
                    </Paper>
                </ValidatorForm>
            </div>
        )
    }
}

const mapStateToProps = (state: ReduxStore): IStateProps => ({

})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>): IDispatchProps => ({
    submitForm: (formData: Partial<TExercise>) => dispatch(formData.id ? OExercise.putItem(formData) : OExercise.postItem(formData))
})

const STYLES = (theme: typeof MuiTheme) => createStyles({
    formPaper: {
        boxSizing: 'border-box',
        width: 650,
        padding: 50,
        position: 'relative',
        '& > div:first-child': {
            margin: '15px 0px',
            '& + div': {
                marginBottom: 15,

            }
        },
        // height: 500
    },
    inputFieldHeight: {
        height: 48,
        marginTop: 25
    },
    editor: {
        height: 'unset'
        // marginTop: 25
    },
    saveButton: {
        position: 'absolute',
        top: 12, right: -30
    },
    backButton: {
        position: 'absolute',
        top: 12, left: 12,
    }
})

export default withRouter(connect<IStateProps, IDispatchProps, OwnProps, ReduxStore>(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(Form)))